<template>
  <section>
    <div>
      <b-field
        class="search-field mb2"
        label=""
      >
      </b-field>
    </div>

    <div class="action-buttons">
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-green is-medium"
          id="clear"
          @click="validateModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-check"></i> Valider les modifications</span>
        </button>
      </div>
      <div class="action-button">
        <button
          v-if="modifiedRows.length"
          class="button field is-danger is-medium"
          id="clear"
          @click="cancelModifications"
          :disabled="!modifiedRows.length"
        >
          <span><i class="fal fa-times"></i> Annuler les modifications</span>
        </button>
      </div>
    </div>

    <div>
      <b-field
        class="search-field"
        label="Rechercher : "
      >
        <b-input
          placeholder="Nom/Prénom/Weezy.."
          type="text"
          v-model="filterEntry"
          @input="filterChanged(filterEntry)"
        ></b-input>
      </b-field>

      <b-select
        v-model="perPage"
        style="padding-left: 20px;"
      >
        <option value="10">10 par page</option>
        <option value="20">20 par page</option>
        <option value="50">50 par page</option>
        <option value="100">100 par page</option>
      </b-select>
    </div>

    <b-table
      class="b-table"
      :data="myData"
      :striped="true"
      :hoverable="true"
      :loading="isLoading"
      paginated
      :per-page="perPage"
      :current-page.sync="currentPage"
      pagination-simple
      :mobile-cards="false"
    >
      <template
        slot-scope="props"
        slot="header"
      >
        <b-tooltip
          :active="!!props.column.meta"
          :label="props.column.meta"
        >
          {{ props.column.label }}
        </b-tooltip>
      </template>
      <template slot-scope="props">

        <b-table-column
          field=avatar
          label="Avatar"
          :centered="true"
          meta="Icône de l'utilisateur"
          width="100"
        >
          <img
            v-if="props.row.img"
            :src="props.row.img"
            alt="image"
          >
          <img
            v-else
            :src="require('@/assets/default-user-icon.jpg')"
            alt="image"
          >
        </b-table-column>

        <b-table-column
          class="b-text-field"
          field="name"
          meta="Matricule SODA de l'utilisateur"
          label="Matricule"
          :centered="true"
          :sortable="true"
        >
          {{ props.row.matricule }}
        </b-table-column>

        <b-table-column
          class="b-text-field"
          field="name"
          meta="Prénom de l'utilisateur"
          label="Prénom"
          :centered="true"
          :sortable="true"
        >
          {{ props.row.name }}
        </b-table-column>

        <b-table-column
          class="b-text-field"
          meta="Nom de famille de l'utilisateur"
          field="surname"
          label="Nom"
          :centered="true"
          :sortable="true"
        >
          {{ props.row.surname }}
        </b-table-column>

        <b-table-column
          class="b-select-weezy"
          field="weezy_id"
          label="Weezy"
          meta="Nom du Weezy auquel l'utilisateur est rattaché"
          :centered="true"
          :sortable="true"
          width="70"
        >
          <b-select
            id="select"
            placeholder="Choisir le Weezy"
            v-model="props.row.weezy_id"
            :required="true"
            @input="toggleModified(props.row)"
          >
            <option :value="null">Aucun</option>
            <option
              v-for="weezy in weezys"
              :key="weezy.id"
              :value="weezy.id"
            >{{weezy.name}}</option>
          </b-select>
        </b-table-column>

      </template>

      <template slot="empty">
        <section class="section">
          <div
            v-if="!isLoading"
            class="content has-text-grey has-text-:centered"
          >
            <p>Pas d'Utilisateurs</p>
          </div>
        </section>
      </template>
    </b-table>
  </section>
</template>

<script>
import http from "@/modules/request";
import _ from "lodash";

export default {
  name: "UsersTable",
  props: ["weezys", "users"],
  data: () => {
    return {
      isEmpty: false,
      isLoading: true,
      modifiedRows: [],
      myData: [],
      storedUsers: [],
      filterEntry: "",
      currentPage: 1,
      perPage: 10
    };
  },
  watch: {
    users: async function(newVal, oldVal) {
      // watch it
      this.storedUsers = JSON.parse(JSON.stringify(this.users));
      this.myData = this.users;
      this.isLoading = false;
      if (this.filterEntry != "") {
        this.isLoading = true;
        this.myData = await this.filterChanged(this.filterEntry);
      }
    }
  },
  methods: {
    downloadModel() {
      var downloadLink = document.createElement("a");
      downloadLink.href =
        "https://api.weezy.soda-armatis.com/static-files/template-weezy-users-avatars-v2.csv";
      //TODO: Find a way choose the filename of the download
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },

    toggleModified(raaw) {
      this.$parent.modifyRows([raaw]);

      // var modified = false;
      // this.modifiedRows.push(raaw);
      // for (var j = 0; j < this.modifiedRows.length; j++) {
      //   var row = this.modifiedRows[j];
      //   for (var i = 0; i < this.storedUsers.length; i++) {
      //     var user = this.storedUsers[i];
      //     if (user.id == row.id) {
      //       if (!(user.weezy_id == row.weezy_id)) {
      //         modified = true;
      //       }
      //     }
      //   }
      //   if (!modified) {
      //     this.modifiedRows = [];
      //   }
      // }
    },
    validateModifications() {
      this.$parent.modifyRows(this.modifiedRows);

      setTimeout(() => {
        this.modifiedRows = [];
        this.storedUsers = JSON.parse(JSON.stringify(this.users));
      }, 100);
    },
    cancelModifications() {
      this.$parent.getUsers();
      setTimeout(() => {
        this.modifiedRows = [];
      }, 100);
    },

    filterChanged: _.debounce(async function(newVal) {
      if (newVal != "") {
        this.myData = this.filteredResults(newVal);
      } else {
        this.myData = this.users;
      }
      this.isLoading = false;
    }, 500),

    filteredResults(string) {
      let result = [];
      for (let user of this.users) {
        var added = false;
        if (
          user.name &&
          user.name.toLowerCase().includes(string.toLowerCase())
        ) {
          result.push(user);
          added = true;
        }
        if (
          !added &&
          user.surname &&
          user.surname.toLowerCase().includes(string.toLowerCase())
        ) {
          result.push(user);
        }
      }

      return result;
    },
    getWeezyName(fromWeezyId) {
      var weezyName = "";
      for (var i = 0; i < this.weezys.length; i++) {
        if (fromWeezyId == this.weezys[i].id) {
          weezyName = this.weezys[i].name;
        }
      }
      return weezyName;
    },

    errorToast(message) {
      this.$parent.$toast.open({
        duration: 5000,
        message: message,
        position: "is-bottom",
        type: "is-danger"
      });
    },

    successToast(message) {
      this.$parent.$toast.open({
        duration: 2000,
        message: message,
        position: "is-bottom",
        type: "is-success"
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* PHONE SIZE*/
@media screen and (max-width: 768px) {
  img {
    height: 25px;
    width: 25px;
    border-radius: 50%;
  }

  .update-button,
  .model-button {
    display: none;
  }
}

/* DESKTOP SIZE */
@media screen and (min-width: 768px) {
  img {
    height: 42px;
    width: 42px;
    border-radius: 50%;
  }
}
</style>